import moment from 'moment-timezone'

export default {
  methods: {
    pickDate (input, format = 'YYYY-MM-DD') {
      if (input === null) {
        return input
      }
      if (input === undefined) {
        return input
      }
      const v = input.trim()
      // 当月月末日を取得
      const last = moment()
        .endOf('month')
        .date()

      // 数値1-2桁のみ受け付ける
      switch (input.length) {
        case 1:
          // 「a」なら月初
          if (v === 'a') {
            return moment()
              .date(1)
              .format(format)
          }
          // 「z」なら月末
          if (v === 'z') {
            return moment()
              .date(last)
              .format(format)
          }
          // 「0」なら当日
          if (v === '0') {
            return moment().format(format)
          }

          if (parseInt(v) > 0 && parseInt(v) < 10) {
            return moment()
              .date(parseInt(v))
              .format(format)
          }

          return v
        case 2:
          const p = /^([0-9]{1,2})$/
          if (!p.test(v)) {
            return v
          }
          // 当月月初から月末日までの日付分の数値を列挙
          const dates = [...Array(last).keys()].map(i => ++i)
          // 当月の有効な日付のみ受け付ける
          if (!dates.includes(parseInt(v, 10))) {
            return v
          }
          // 日付を設定して、有効な日付か最終チェック。
          const x = moment().date(v)
          if (x.isValid()) {
            return x.format(format)
          }
          return v
        case 3:
          let month3 = input.slice(0, 1)
          let day3 = input.slice(1, 3)
          return this.returnDate(null, '0' + month3, day3, format)
        case 4:
          let month4 = input.slice(0, 2)
          let day4 = input.slice(2, 4)
          return this.returnDate(null, month4, day4, format)
        case 6:
          let year6 = input.slice(0, 2)
          let month6 = input.slice(2, 4)
          let day6 = input.slice(4, 6)
          return this.returnDate(year6, month6, day6, format)
        case 8:
          let year8 = input.slice(0, 4)
          let month8 = input.slice(4, 6)
          let day8 = input.slice(6, 8)
          return this.returnDate(year8, month8, day8, format)
        case 10:
          let year10 = input.slice(0, 4)
          let month10 = input.slice(5, 7)
          let day10 = input.slice(8, 10)
          return this.returnDate(year10, month10, day10, format)
        default:
          return v
      }
    },
    returnDate (year, month, date, format) {
      let returnYear = year
      if (parseInt(year) < 100) {
        returnYear = `20${year}`
      } else if (year === null) {
        returnYear = new Date().getFullYear()
      }
      let lastDayOfMonth = moment(`${returnYear}-${month}`).endOf('month').format('DD')
      let dateOfMonth = date
      let monthOfYear = parseInt(month) - 1
      if (month > 12) {
        monthOfYear = 11
      }
      if (parseInt(date) > parseInt(lastDayOfMonth)) {
        dateOfMonth = lastDayOfMonth
      }
      if (lastDayOfMonth === 'Invalid date') {
        if (year === null) {
          return `${month}${date}`
        }
        return `${year}${month}${date}`
      }
      return moment().year(returnYear).month(monthOfYear).date(dateOfMonth).format(format)
    },
    getDayOfWeekJapanese (date) {
      let idDayOfWeek = this.$moment(date).day()
      let dayOfWeek = null

      switch (idDayOfWeek) {
        case 0:
          dayOfWeek = '日'
          break
        case 1:
          dayOfWeek = '月'
          break
        case 2:
          dayOfWeek = '火'
          break
        case 3:
          dayOfWeek = '水'
          break
        case 4:
          dayOfWeek = '木'
          break
        case 5:
          dayOfWeek = '金'
          break
        case 6:
          dayOfWeek = '土'
          break
        default:
          break
      }
      return dayOfWeek
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/mixins/datepick.js